import React, { Fragment } from "react";
import useSportsBookLogic from "../../useLogic/useSportbookLogic";
import { isEmpty } from "lodash";
import BetSlipSkyWeb from "./BetSlip";
import { useContextSelector } from "use-context-selector";
import BetSlipContext from "../../../context/BetSlipContext";
import Message from "./Message";

const SportbookWebSky = ({
  setFancyTab,
  data,
  user,
  detail,
  profileData,
  setBetSlipObject,
  favouriteList,
  position,
  BetSlip,
  addToFavioute,
}) => {
  const toastObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.toastObject;
  });
  const setToastObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setToastObject;
  });
  const {
    setHeader,
    selected,
    setSelected,
    active,
    setActive,
    handelChange,
    sportBookCheck,
    updatedData,
    parlyBet,
    parlay,
    betSlipObject,
    showBetDialog,
  } = useSportsBookLogic({
    data,
    user,
    detail,
    profileData,
    setBetSlipObject,
    favouriteList,
    position,
    BetSlip,
    addToFavioute,
  });
  return (
    <div id="sportsBookWrap" className="bets-wrap sportsbook_bet">
      <div id="sportsBookHead" className="sportsbook-head">
        <h4 className="in-play">
          <span id="sportsBookName">Premium Cricket</span>
          <a id="sportsBookRules" className="btn-sportsbook_rules">
            Rules
          </a>
        </h4>
        {detail?.gameType == "cricket" && detail?.hasFancy ? (
          <a
            onClick={() => setFancyTab("Fancy")}
            id="showFancyBetBtn"
            className="other-tab"
            style={{}}
          >
            Fancy Bet
          </a>
        ) : (
          ""
        )}
        <div id="sportsBookRulesWrap_2" className="rules-wrap">
          <h3 id="sportsbookRulesTitle" />
          <div id="sportradarCricketRules" className="rules-content">
            <dl className="download-list">
              <dt className="icon-pdf">
                <a href="javascript: void(window.open('https://qrfja642ej4ug9a.s3.ap-southeast-1.amazonaws.com/rule/Pre_Match_Premium_Cricket_Market_Details.pdf', '_blank', config = 'location=no'));">
                  Pre Match Market Details
                </a>
              </dt>
              <dd>
                <a href="javascript: void(window.open('https://qrfja642ej4ug9a.s3.ap-southeast-1.amazonaws.com/rule/Pre_Match_Premium_Cricket_Market_Details.pdf', '_blank', config = 'location=no'));">
                  download
                </a>
              </dd>
            </dl>
            <dl className="download-list">
              <dt className="icon-pdf">
                <a href="javascript: void(window.open('https://qrfja642ej4ug9a.s3.ap-southeast-1.amazonaws.com/rule/In_Play_Premium_Cricket_Market_Details.pdf', '_blank', config = 'location=no'));">
                  In Play Market Details
                </a>
              </dt>
              <dd>
                <a href="javascript: void(window.open('https://qrfja642ej4ug9a.s3.ap-southeast-1.amazonaws.com/rule/In_Play_Premium_Cricket_Market_Details.pdf', '_blank', config = 'location=no'));">
                  download
                </a>
              </dd>
            </dl>
          </div>
          <div id="sportradarTennisRules" className="rules-content">
            <p>General Rules:</p>
            <ol>
              <li>
                In case of default, retirement or walkover of any player, all
                undecided bets are considered void.
              </li>
              <li>
                In case of any delay (rain, darkness…) all markets remain
                unsettled and the trading will be continued as soon as the match
                continues.
              </li>
              <li>
                If penalty point(s) are awarded by the umpire, all bets on that
                game will stand.
              </li>
              <li>
                In case of a match is finished before certain points/games were
                finished, all affected point/game related markets are considered
                void.
              </li>
            </ol>
            <p>Settlement and Cancellation Rules:</p>
            <ol>
              <li>
                If markets remain open with an incorrect score which has a
                significant impact on the prices, we reserve the right to void
                betting.
              </li>
              <li>
                If the players/teams are displayed incorrectly, we reserve the
                right to void betting.
              </li>
              <li>
                If a player retires all undecided markets are considered void.
              </li>
              <li>
                If a match tie-break is played as a deciding set in Bo3 format,
                it will be considered as the 3rd set
              </li>
              <li>Every tie-break or Match tie-break counts as 1 game</li>
            </ol>
          </div>
          <div id="sportradarSoccerRules" className="rules-content">
            <dl className="download-list">
              <dt className="icon-pdf">
                <a href="javascript: void(window.open('https://qrfja642ej4ug9a.s3.ap-southeast-1.amazonaws.com/rule/SR_Premium_Soccer_Rules.pdf', '_blank', config = 'location=no'));">
                  Market Details
                </a>
              </dt>
              <dd>
                <a href="javascript: void(window.open('https://qrfja642ej4ug9a.s3.ap-southeast-1.amazonaws.com/rule/SR_Premium_Soccer_Rules.pdf', '_blank', config = 'location=no'));">
                  download
                </a>
              </dd>
            </dl>
          </div>
          <div id="sportradarKabaddiRules" className="rules-content">
            <dl className="download-list">
              <dt className="icon-pdf">
                <a href="javascript: void(window.open('https://qrfja642ej4ug9a.s3.ap-southeast-1.amazonaws.com/rule/SR_General_Rules.pdf', '_blank', config = 'location=no'));">
                  General Rules
                </a>
              </dt>
              <dd>
                <a href="javascript: void(window.open('https://qrfja642ej4ug9a.s3.ap-southeast-1.amazonaws.com/rule/SR_General_Rules.pdf', '_blank', config = 'location=no'));">
                  download
                </a>
              </dd>
            </dl>
          </div>
          <ul className="btn-wrap break">
            <li>
              <a
                onclick="$j('#sportsBookRulesWrap_2').fadeOut()"
                className="btn"
                href="#"
              >
                OK
              </a>
            </li>
          </ul>
        </div>
        <div id="sportsBookRulesWrap_4" className="rules-wrap">
          <h3 id="geniussportsRulesTitle" />
          <div id="geniussportsCricketRules" className="rules-content">
            <dl className="download-list">
              <dt className="icon-pdf">
                <a href="javascript: void(window.open('https://qrfja642ej4ug9a.s3.ap-southeast-1.amazonaws.com/rule/prematch_Cricket_Rules.pdf', '_blank', config = 'location=no'));">
                  Pre Match Cricket
                </a>
              </dt>
              <dd>
                <a href="javascript: void(window.open('https://qrfja642ej4ug9a.s3.ap-southeast-1.amazonaws.com/rule/prematch_Cricket_Rules.pdf', '_blank', config = 'location=no'));">
                  download
                </a>
              </dd>
            </dl>
            <dl className="download-list">
              <dt className="icon-pdf">
                <a href="javascript: void(window.open('https://qrfja642ej4ug9a.s3.ap-southeast-1.amazonaws.com/rule/Cricket_Rules.pdf', '_blank', config = 'location=no'));">
                  In Play Cricket
                </a>
              </dt>
              <dd>
                <a href="javascript: void(window.open('https://qrfja642ej4ug9a.s3.ap-southeast-1.amazonaws.com/rule/Cricket_Rules.pdf', '_blank', config = 'location=no'));">
                  download
                </a>
              </dd>
            </dl>
          </div>
          <div id="geniussportsTennisRules" className="rules-content">
            <dl className="download-list">
              <dt className="icon-pdf">
                <a href="javascript: void(window.open('https://qrfja642ej4ug9a.s3.ap-southeast-1.amazonaws.com/rule/prematch_Tennis_Rules.pdf', '_blank', config = 'location=no'));">
                  Pre Match Tennis
                </a>
              </dt>
              <dd>
                <a href="javascript: void(window.open('https://qrfja642ej4ug9a.s3.ap-southeast-1.amazonaws.com/rule/prematch_Tennis_Rules.pdf', '_blank', config = 'location=no'));">
                  download
                </a>
              </dd>
            </dl>
            <dl className="download-list">
              <dt className="icon-pdf">
                <a href="javascript: void(window.open('https://qrfja642ej4ug9a.s3.ap-southeast-1.amazonaws.com/rule/Tennis_Rules.pdf', '_blank', config = 'location=no'));">
                  In Play Tennis
                </a>
              </dt>
              <dd>
                <a href="javascript: void(window.open('https://qrfja642ej4ug9a.s3.ap-southeast-1.amazonaws.com/rule/Tennis_Rules.pdf', '_blank', config = 'location=no'));">
                  download
                </a>
              </dd>
            </dl>
          </div>
          <div id="geniussportsSoccerRules" className="rules-content">
            <dl className="download-list">
              <dt className="icon-pdf">
                <a href="javascript: void(window.open('https://qrfja642ej4ug9a.s3.ap-southeast-1.amazonaws.com/rule/prematch_Football_Rules.pdf', '_blank', config = 'location=no'));">
                  Pre Match Soccer
                </a>
              </dt>
              <dd>
                <a href="javascript: void(window.open('https://qrfja642ej4ug9a.s3.ap-southeast-1.amazonaws.com/rule/prematch_Football_Rules.pdf', '_blank', config = 'location=no'));">
                  download
                </a>
              </dd>
            </dl>
            <dl className="download-list">
              <dt className="icon-pdf">
                <a href="javascript: void(window.open('https://qrfja642ej4ug9a.s3.ap-southeast-1.amazonaws.com/rule/Football_Rules.pdf', '_blank', config = 'location=no'));">
                  In Play Soccer
                </a>
              </dt>
              <dd>
                <a href="javascript: void(window.open('https://qrfja642ej4ug9a.s3.ap-southeast-1.amazonaws.com/rule/Football_Rules.pdf', '_blank', config = 'location=no'));">
                  download
                </a>
              </dd>
            </dl>
          </div>
          <ul className="btn-wrap break">
            <li>
              <a
                onclick="$j('#sportsBookRulesWrap_4').fadeOut()"
                className="btn"
                href="#"
              >
                OK
              </a>
            </li>
          </ul>
        </div>
        <dl
          id="minMaxWrap_4"
          className="fancy-info"
          style={{ display: "none" }}
        >
          <dt>
            <span>Min</span>
          </dt>
          <dd id="minMaxInfo_4">0</dd>
          <dt id="rebateName_4">Rebate</dt>
          <dd id="rebateRatio_4">0.00%</dd>
        </dl>
        <dl
          id="minMaxWrap_2"
          className="fancy-info"
          style={{ display: "none" }}
        >
          <dt>
            <span>Min</span>
          </dt>
          <dd id="minMaxInfo_2">0</dd>
          <dt id="rebateName_2">Rebate</dt>
          <dd id="rebateRatio_2">0.00%</dd>
        </dl>
      </div>
      <div id="sportsBookTab_2_4" className="special_bets-tab-wrap" style={{}}>
        <ul className="special_bets-tab">
          {premiumCategoryArray?.map((res, index) => {
            return (
              <li
                onClick={() => {
                  setHeader(res?.type);
                }}
              >
                <a id="tab_All"> {res?.name}</a>
              </li>
            );
          })}
        </ul>
      </div>

      {updatedData?.length > 0 ? (
        updatedData?.map((item, index) => {
          if (item?.sportsBookSelection?.length > 0) {
            let lockOuter =
              item?.apiSiteStatus == "SUSPENDED" || item?.marketStatus != 1;
            let animate = favouriteList?.includes(item.id);
            return (
              <table
                id="sportsBookMarket_2_4325472_847359062"
                className={`bets ${!active.includes(index) ? "close" : ""}`}
                style={{}}
              >
                <colgroup>
                  <col span={1} width={280} />
                  <col span={1} width={70} />
                  <col span={1} width={70} />
                  <col span={1} width={70} />
                  <col span={1} width={70} />
                  <col span={1} width={70} />
                  <col span={1} width={70} />
                </colgroup>
                <tbody>
                  <tr className="colgroup-adjust">
                    <td />
                    <td />
                    <td />
                    <td />
                    <td />
                    <td />
                    <td />
                  </tr>
                  <tr className="special_bet">
                    <td colSpan={7}>
                      <h3 id="marketHeader">
                        <a
                          id="multiMarketPin"
                          className="add-pin"
                          title="Add to Multi Markets"
                        >
                          Add Pin
                        </a>
                        <a
                          onClick={() =>
                            setActive((prev) => {
                              if (prev.includes(index)) {
                                return prev?.filter((obj) => {
                                  return obj != index;
                                });
                              } else {
                                return [...prev, index];
                              }
                            })
                          }
                          id="marketName"
                          className="to-expand"
                        >
                          {item?.marketName}
                        </a>
                      </h3>
                    </td>
                  </tr>

                  {active.includes(index) &&
                    item?.sportsBookSelection?.map((res, id) => {
                      if (Number(res?.odds) > 0) {
                        let newPosition = "";
                        if (
                          showBetDialog &&
                          betSlipObject?.playType == "sportBook" &&
                          item?.id == selected
                        ) {
                          let backProfit =
                            (Number(betSlipObject?.odds) - 1) *
                            Number(betSlipObject?.bidPrice);
                          let backLoss = Number(betSlipObject?.bidPrice);
                          if (res?.id == betSlipObject?.object?.id) {
                            newPosition =
                              Math.abs(res?.position) > 0
                                ? Number(backProfit) + Number(res.position)
                                : Number(backProfit);
                          } else {
                            newPosition =
                              Math.abs(res?.position) > 0
                                ? Number(res?.position) - Number(backLoss)
                                : -Number(backLoss);
                          }
                        }

                        let conditionPosition =
                          showBetDialog &&
                          betSlipObject?.object?.id == res?.id &&
                          betSlipObject?.item?.id == item?.id &&
                          betSlipObject?.playType == "sportBook";
                        let lock =
                          res?.isActive != 1 ||
                          item?.apiSiteStatus == "SUSPENDED" ||
                          item?.marketStatus != 1;

                        return (
                          <Fragment>
                            {" "}
                            {res?.isActive != 1 && (
                              <tr className="fancy-suspend-tr">
                                <th colSpan={3} />
                                <td className="fancy-suspend-td" colSpan={2}>
                                  <div
                                    id="suspendClass"
                                    className="fancy-suspend-white"
                                  >
                                    <span>Suspend</span>
                                  </div>
                                </td>
                                <td colSpan={2} />
                              </tr>
                            )}
                            <tr
                              id="sportsBookSelection_2_4325472_847359062_2216539330"
                              style={{ display: "table-row" }}
                              marketpk="2_4325472_847359062"
                              isactive={1}
                              status={1}
                            >
                              <th className colSpan={3}>
                                <dl className="fancy-th-layout">
                                  <dt>
                                    <p id="selectionName">
                                      {res?.selectionName}
                                    </p>
                                    {Math.abs(res?.position) > 0 && (
                                      <span
                                        id="before"
                                        className={
                                          res?.position > 0 ? "win" : "lose"
                                        }
                                      >
                                        {res?.position > 0
                                          ? Math.abs(res?.position).toFixed(2)
                                          : `(${Math.abs(res?.position).toFixed(
                                              2
                                            )})`}
                                      </span>
                                    )}
                                    {!isNaN(Math.abs(newPosition) > 0) &&
                                      conditionPosition &&
                                      Number(betSlipObject?.bidPrice) > 0 && (
                                        <span
                                          id="after"
                                          className={`to-${
                                            newPosition > 0 ? "win" : "lose"
                                          } `}
                                        >
                                          {newPosition > 0
                                            ? Math.abs(newPosition).toFixed(2)
                                            : `(${Math.abs(newPosition).toFixed(
                                                2
                                              )})`}
                                        </span>
                                      )}
                                  </dt>
                                </dl>
                              </th>
                              <td
                                onClick={(e) => {
                                  if (!lock) {
                                    handelChange(res?.odds, item, res, e);
                                    setSelected(item?.id);
                                  }
                                }}
                                id="back_1"
                                className={`back-1 no-liq ${
                                  conditionPosition ? "select" : ""
                                }`}
                                colSpan={2}
                              >
                                <a id="info"> {res?.odds}</a>
                              </td>
                              <td className="refer-book" colSpan={2} />
                            </tr>
                            {conditionPosition && <BetSlipSkyWeb />}{" "}
                            {!isEmpty(toastObject?.message) &&
                              toastObject?.status &&
                              toastObject?.gameType == "sportbook" &&
                              toastObject?.id == res?.id && (
                                <Message
                                  toastObject={toastObject}
                                  setToastObject={setToastObject}
                                />
                              )}
                          </Fragment>
                        );
                      }
                    })}
                </tbody>
              </table>
            );
          }
        })
      ) : (
        <p id="sportsBookNoBet" className="no_bet" style={{}}>
          has no Sports Book market{" "}
        </p>
      )}
    </div>
  );
};

export default SportbookWebSky;
const premiumCategoryArray = [
  { type: "all", name: "All" },
  { type: "Popular", name: "Popular" },
  { type: "Match", name: "Match" },
  { type: "Innings", name: "Innings" },
  { type: "Over", name: "Over" },
  { type: "Batsman", name: "Batsman" },
];
